<script>
  import { onDestroy, onMount } from 'svelte';
  import { initCameraElements, clearCameraElements, bootCamera } from '../../media/camera-service.js';

  let videoElement;
  let canvasElement;

  // Svelte does not await an async onMount, and onDestroy runs synchronously.
  // Navigating away mid-boot therefore ran clearCameraElements FIRST and then
  // bootCamera attached a live stream to detached elements — an orphaned camera
  // track plus a zombie draw loop eating battery in the background.
  let destroyed = false;

  onMount(async () => {
    if (videoElement && canvasElement) {
      initCameraElements(videoElement, canvasElement);
      await bootCamera();
      if (destroyed) clearCameraElements(videoElement, canvasElement);
    }
  });

  onDestroy(() => {
    destroyed = true;
    clearCameraElements(videoElement, canvasElement);
  });
</script>

<div class="broadcast-overlay">
  <video id="cam-video" bind:this={videoElement} autoplay playsinline muted aria-label="Live camera preview"></video>
  <canvas id="cam-canvas" bind:this={canvasElement} aria-label="Recorded broadcast output"></canvas>
</div>

<style>
  .broadcast-overlay {
    position: relative;
    width: 100%;
    height: 100%;
    background: #000;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  #cam-video {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
    background: #000;
    opacity: 0;
  }

  #cam-canvas {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: contain; /* The canvas contains the 16:9 720p/1080p overlay */
    z-index: 2;
    pointer-events: none;
  }
</style>
